exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-filemanager-plugin,#asseco-filemanager .asseco-floaty-btn{background-color:#e53935}", ""]);

// exports
